import api from './version';

export function getInvoiceEndpointURL(billingAccountId: string, invoiceNumber: string,
    invoiceIssueDate?: string, invoiceIssueDateForLegacyDownload: boolean = false): string {
    const invoicePDFDownloadURL = invoiceIssueDateForLegacyDownload ? `/billing/${api.version}/account/` +
        `${billingAccountId}/invoice?invoiceNumber=${invoiceNumber}&invoiceIssueDate=${invoiceIssueDate}` :
        `/billing/${api.version}/account/${billingAccountId}/invoice?invoiceNumber=${invoiceNumber}`
    return invoicePDFDownloadURL;
}

export function getInvoiceDetailsEndpointURL(invoiceNumber: string, hashId: string) {
    const invoiceDetailsPDFDownload = `/billing/${api.version}/invoices/download-pdf/${invoiceNumber}/billDocument/${hashId}`
    return invoiceDetailsPDFDownload;
}

export function getLargeFileDownloadPdfPath(billingAccountId: string) {
    return `/billing/${api.version}/account/${billingAccountId}/legacyDownloadLargePdf`
}

export function getIntInvoiceEndpointURL(banId: string, invNumber: string, pCid: string): string {
    return `/billing/${api.version}/account/${banId}/invoice?invoiceNumber=${invNumber}&parentCompanyId=${pCid}`;
}

export function postIntInvoiceEndpointURL(accountId: string, pCid: string): string {
    return `/billing/${api.version}/account/${accountId}/downloadBills?parentCompanyId=${pCid}`;
}

export function getInvoiceDetailsCsvEndpointURL(billingAccountId: string, invoiceNumber: string): string {
    return `/billing/${api.version}/export/invoice/${billingAccountId}?invoiceNumber=${invoiceNumber}`;
}

export function getBillingExportsURL(billingAccountId: string): string {
    return `/billing/${api.version}/export/invoices/${billingAccountId}`;
}

export function getIntBillingExportsURL(billingAccountId: string, pCid: string): string {
    return `/billing/${api.version}/export/invoices/${billingAccountId}?parentCompanyId=${pCid}`;
}

export function getInvoiceExportsURL(): string {
    return `/billing/${api.version}/export/invoices`;
}

export function getIntBillingPdfCsvURL(billingAccountId: string, pCid: string): string {
    return `/billing/${api.version}/account/${billingAccountId}/downloadBills?parentCompanyId=${pCid}`;
}

export function getBillingPaymentsExportURL(billingAccountId: string): string {
    return `/billing/${api.version}/export/transactions/${billingAccountId}`
}

export function getBillingAdjustmentsExportURL(billingAccountId: string): string {
    return `/billing/${api.version}/export/adjustments/${billingAccountId}`
}

export function getIntBillingAdjustmentsExportURL(billingAccountId: string, pCid: string): string {
    return `/billing/${api.version}/export/adjustments/${billingAccountId}?parentCompanyId=${pCid}`
}

export function getPaymentDetailsUrl(billingAccountId: string): string {
    return `/billing/${api.version}/account/${billingAccountId}/payments`;
}

export function getCreditEndpointURL(billingAccountId: string, creditNumber: string): string {
    return `/billing/${api.version}/account/${billingAccountId}/credit?creditNumber=${creditNumber}`;
}

export function getIntCreditEndpointURL(banId: string, cNumber: string, pCid: string): string {
    return `/billing/${api.version}/account/${banId}/credit?creditNumber=${cNumber}&parentCompanyId=${pCid}`;
}

export function getDrillDownExportCsvEndpointURL(billingAccountId: string, typeOfDrillDown: string): string {
    return `/billing/${api.version}/export/drilldown/${billingAccountId}?typeOfDrillDown=${typeOfDrillDown}`;
}

export function getDownloadFromS3EndpointURL(billingAccountId: string, fileName: string) {
    return `/billing/${api.version}/account/${billingAccountId}/downloadInvoiceFromS3?fileName=${fileName}`
}

export function getDownloadQueriedChargesCSV(billingAccountId: string, caseNumber: string) {
    const csvUrl = billingAccountId ?
        `/billing/${api.version}/export/enquiry/${billingAccountId}/${caseNumber}`
        :
        `/billing/${api.version}/export/queriedcharge/${caseNumber}`
    return csvUrl;
}

export function getEnquiryListCSV(billingAccountId: string) {
    return `/billing/${api.version}/export/enquiry/${billingAccountId}`
}

export function getdownloadSingleCSVEndpointURL(billingAccountId: string, fileName: string) {
    return `/billing/${api.version}/account/${billingAccountId}/downloadSingleCSV?fileName=${fileName}`
}

export function getDetailedCSVEndpointURL(billingAccountId: string) {
    return `/billing/${api.version}/account/${billingAccountId}/downloadDetailedCSV`
}
